import { ObjectStorage } from "../ObjectStorage";

class AuthStorage extends ObjectStorage {
    public isSecure = true;
    public key = 'auth5.0';
}

export default AuthStorage.getInstance(AuthStorage);
